// extracted by mini-css-extract-plugin
export var box = "_5v-1";
export var checkboxRow = "_5v-8";
export var checked = "_5v-2";
export var descriptionSpacer = "_5v-a";
export var disabled = "_5v-3";
export var icon = "_5v-6";
export var input = "_5v-0";
export var labelSpacer = "_5v-9";
export var medium = "_5v-5";
export var small = "_5v-4";
export var text = "_5v-7";